/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { isEmpty } from '@ember/utils';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { loadRecordsInChunks } from 'linced-app/utils/api';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import { service } from '@ember/service';
import { alias } from '@ember/object/computed';
import {
  compact,
  filterBy,
  mapBy,
  uniq,
} from '@linc-technologies/linced-common/utils/arrays';

export default class AdminRoute extends Route {
  // Services
  @service
  session;

  @service
  store;

  // Attrs
  @alias('session.school.jurisdiction')
  jurisdiction;

  model(params) {
    let dateId = params.date_id;
    let store = this.store;
    let schoolId = this.get('session.activeSchool');
    let date = store.findRecord('date', dateId);
    let auditLogs = date.then((date) => {
      if (this.jurisdiction !== Jurisdiction.NZ_MOE) {
        return this.store.query('attendance/audit', {
          schoolId,
          dateFrom: date.date,
          dateTo: date.date,
        });
      }
    });

    return hash({
      students: store.query('person', { type: PersonType.LEARNER }),
      date,
      records: store.query('attendance/record', { dateId }),
      registers: store.query('attendance/register', { dateId }),
      alertLogs: store.query('attendance/alert-log', { dateId }),
      auditLogs,
    });
  }

  afterModel(model) {
    // If we have any unexplained absences, retrieve associated caregivers and initialise their fields.
    let unexplained = model.records.filter((record) => record.code === '?');
    if (isEmpty(unexplained)) {
      return;
    }

    let contactIds = [];
    unexplained.forEach((record) => {
      let contacts = record.get('person.learner.primaryContacts');
      if (!isEmpty(contacts)) {
        contactIds.push(
          ...mapBy(filterBy(contacts, 'receivesSms'), 'caregiverId'),
        );
      }
    });
    if (!isEmpty(contactIds)) {
      // Request caregivers in blocks of 50 to avoid generating URLs which exceed the maximum length.
      return loadRecordsInChunks(
        this.store,
        'person',
        'people',
        uniq(compact(contactIds)),
        50,
      );
    }
  }

  resetController(controller) {
    controller.resetFilters();
  }
}
